const VehicleInStatusTypeEnum = {
  Stock: 1,
  Service: 2,
  Industrial: 3,
  OnTheRoad: 4,
  Rent: 5,
  Escrow: 6,
  Expertize: 7,
  Saled: 8,
  Optioned: 9,
  OutList:10
};

export default VehicleInStatusTypeEnum;
